import { IUser } from '@module/userManagement/models';
import { IUserToken } from '../models';

class AuthorizedUserServiceClass {
  private basePath: string;

  constructor() {
    this.basePath = `${environmentSettings.apiUrl}Users/`;
  }

  async getUserByEmail(email: string, accessToken: IUserToken): Promise<IUser> {
    const response = await this.sendRequest(email, 'GET', accessToken);
    if (response.status === 204) {
      return null as unknown as IUser;
    }
    if (response.ok) {
      const json = await response.json();
      return json;
    } else {
      throw new Error(`System error: ${response.status} ${response.statusText}`);
    }
  }

  private sendRequest(email: string, httpMethod: string, accessToken: IUserToken) {
    const headers = new Headers();
    // support several shapes: oidc user object, token object, or raw token string
    let tokenValue: string | undefined;
    try {
      if (!accessToken) {
        tokenValue = undefined;
      } else if (typeof (accessToken as any) === 'string') {
        tokenValue = accessToken as any;
      } else {
        tokenValue = (accessToken as any).access_token || (accessToken as any).accessToken || (accessToken as any).id_token;
      }
    } catch (e) {
      console.error('Failed to read access token', e);
      tokenValue = undefined;
    }
    if (tokenValue) {
      headers.append('Authorization', 'Bearer ' + tokenValue);
    }
    headers.append('pragma', 'no-cache');
    headers.append('cache-control', 'no-cache');
    headers.append('access-control-allow-methods', 'GET, HEAD, POST, PUT, PATCH, DELETE, OPTIONS');
    return fetch(`${this.basePath}GetUserByEmail/${email}`, { headers, method: httpMethod, cache: 'no-store' });
  }
}

export const AuthorizedUserService = new AuthorizedUserServiceClass();
export default AuthorizedUserService;
